import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import React, { Component } from 'react';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import { globalStyles } from '../../core/style/gstheme';
import CreateConceptDialog from './CreateConceptDialog';
const styles = Object.assign({}, globalStyles);

class CreateConceptDialogContainer extends Component {

  render() {

    const { classes, onOpen, onClose, onAddNewConcept, parentIRI, schemeIRI, useSlashIRI, useUuidIRI, useCounterIRI,
      graph, onAddExistingConcept, useXL, iriOptions, useWorkflow, counters } = this.props;

    return (
      <ProjectConsumer>
        {({ id: projectIRI, skosXL, defaultLang }) => (
          <CreateConceptDialog
            button={
              <Tooltip title="Add a child concept">
                <IconButton className={classes.smallIconButton} style={{ color: 'white' }}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            }
            graph={graph}
            optionForXL={skosXL}
            useXL={useXL}
            useWorkflow={useWorkflow}
            defaultLang={defaultLang}
            schemeIRI={schemeIRI}
            iriOptions={iriOptions}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}  
            useCounterIRI={useCounterIRI}
            counters={counters}
            parentIRI={parentIRI}
            sourceIRI={parentIRI}
            onOpen={onOpen}
            onClose={onClose}
            property='narrower'
            projectIRI={projectIRI}
            onAddExistingConcept={onAddExistingConcept}
            onAddNewConcept={onAddNewConcept}
            title="Add Narrower Concept" />
        )}
      </ProjectConsumer>
    );
  }

}

CreateConceptDialogContainer.propTypes = {
  onOpen: PropTypes.func,
  graph: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  schemeIRI: PropTypes.string.isRequired,
  parentIRI: PropTypes.string.isRequired,
  useXL: PropTypes.bool,
  useWorkflow: PropTypes.bool,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  useCounterIRI: PropTypes.bool,
  counters: PropTypes.object,
  onAddExistingConcept: PropTypes.func.isRequired,
  onAddNewConcept: PropTypes.func.isRequired,
  classes: PropTypes.object,
  iriOptions: PropTypes.object
};

export default withStyles(styles)(CreateConceptDialogContainer);